import {CanActivateFn, Router} from '@angular/router';
import {inject} from "@angular/core";
import {UserDataService} from "../services/user-data.service";

export const authGuard: CanActivateFn = (route, state) => {
  const userDataService = inject(UserDataService);
  const router = inject(Router);
  const isAuthenticated = userDataService.isAuthenticated();
  if (isAuthenticated) return true;
  router.navigateByUrl('/system');
  return false;
};
